 
export enum ExportOptions {
    PDF = 'PDF',
    EXCEL = 'Excel',
}
